import { dayjs } from '@contra/date';

type WorkPreferenceAvailabilityDate = ContraAPIScalars.Date | null | undefined;

const getUTCToday = () => {
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  return today;
};

export const getUTCStartOfDayString = () => {
  return getUTCToday().toISOString();
};

export const getMaxWorkPreferenceAvailabilityDate =
  (): ContraAPIScalars.Date => {
    const today = getUTCStartOfDayString();
    const maxDate = dayjs(today).add(30, 'day').toDate();
    maxDate.setUTCHours(0, 0, 0, 0);

    const maxDateString = maxDate.toISOString();
    return maxDateString;
  };

export const canExtendAvailability = (
  availabilityDate: WorkPreferenceAvailabilityDate,
): boolean => {
  if (!availabilityDate) {
    return true;
  }

  const maxUTCDateString = getMaxWorkPreferenceAvailabilityDate();

  const utcAvailabilityDate = new Date(availabilityDate);
  utcAvailabilityDate.setUTCHours(0, 0, 0, 0);
  const utcAvailabilityDateString = utcAvailabilityDate.toISOString();

  const isBefore = dayjs(utcAvailabilityDateString).isBefore(
    dayjs(maxUTCDateString),
  );

  return isBefore;
};

export const getAvailabilityStatusText = ({
  availableUntil,
  isCurrentlyAvailable,
}: {
  availableUntil: null | string;
  isCurrentlyAvailable: boolean;
}) => {
  if (isCurrentlyAvailable && availableUntil) {
    // validate that the date is not in the past even though we get
    // isCurrentlyAvailable from the server
    const currentDate = new Date();
    const availableUntilDate = new Date(availableUntil);
    const isActuallyAvailable = dayjs(currentDate).isBefore(
      dayjs(availableUntilDate),
    );

    if (isActuallyAvailable) {
      return `accepting new Clients until ${dayjs(availableUntil).format(
        'MMMM DD, YYYY',
      )}`;
    }
  }

  return 'no longer accepting new Clients';
};
